import api from '@/api/statements';
import store from '@/store/store';

const fetchStatements = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.fetchStatements(criteria.pageIndex, criteria.searchTerm, criteria.locationIds, criteria.categoryId, criteria.hasTask, criteria.matureSoon, criteria.needAll,criteria.orderInfo,criteria.siteId, criteria.specializations)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeStatementList', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const fetchStatement = (context, id) => {
  return new Promise(((resolve, reject) => {
    api.fetchStatement(id)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeStatement', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const fetchStatementWithInspection = (context, id) => {
  return new Promise(((resolve, reject) => {
    api.fetchStatementWithInspection(id)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeStatement', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const createStatement = (context, params) => {
  return new Promise(((resolve, reject) => {
    api.createStatement(params)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeCreatedStatement', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const updateStatement = (context, params) => {
  return new Promise(((resolve, reject) => {
    api.updateStatement(params)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeUpdatedStatement', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const deleteStatement = (context, id) => {
  return new Promise(((resolve, reject) => {
    api.deleteStatement(id)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const createBaseState = (context, params) => {
  return new Promise(((resolve, reject) => {
    api.createBaseState(params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const fetchPreviousBaseStates = (context, page) => {
  return new Promise(((resolve, reject) => {
    api.fetchPreviousBaseStates(page)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const fetchPreviousBaseState = (context, id) => {
  return new Promise(((resolve, reject) => {
    api.fetchPreviousBaseState(id)
      .then((response) => {
        resolve(response);
        store.commit('statements/storeStatementList', response.statements);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const updateBaseState = (context, params) => {
  return new Promise(((resolve, reject) => {
    api.updateBaseState(params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

export default {
  fetchStatements,
  fetchStatement,
  createStatement,
  updateStatement,
  deleteStatement,
  fetchStatementWithInspection,
  createBaseState,
  fetchPreviousBaseStates,
  fetchPreviousBaseState,
  updateBaseState
};




// WEBPACK FOOTER //
// ./src/store/modules/statements/actions.js